import { createApp, defineAsyncComponent } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

const AsyncHelloWorld = defineAsyncComponent(() =>
  import('./components/HelloWorld.vue')
)

const app = createApp(App)

app.component('AsyncHelloWorld', AsyncHelloWorld)

app.use(store).use(router).mount('#app')
